import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY, NAV_LINKS } from "../lib/constants";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0F5132] text-white"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <div className="h-16 w-16 rounded-2xl bg-white flex items-center justify-center p-2 shadow-md">
                <img src={COMPANY.logo} alt="Logo Impresa Edile Lici" className="h-full w-full object-contain" />
              </div>
              <div>
                <div className="font-serif text-xl">Impresa Edile Lici</div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-white/70">
                  S.a.s. di Lici Armand e C.
                </div>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-white/80 max-w-md">
              Oltre 20 anni di esperienza nella progettazione, installazione e manutenzione di
              impianti fotovoltaici civili e industriali. Specialisti del lavaggio professionale dei
              pannelli.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-serif text-lg mb-5">Naviga</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-white/80 hover:text-[#D97706] transition-colors"
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-serif text-lg mb-5">Contatti</h4>
            <ul className="space-y-4 text-sm text-white/85">
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 mt-1 text-[#D97706]" />
                <a href={COMPANY.phoneHref} className="hover:text-white" data-testid="footer-phone">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 mt-1 text-[#D97706]" />
                <a href={COMPANY.emailHref} className="hover:text-white break-all" data-testid="footer-email">
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-1 text-[#D97706]" />
                <a
                  href={COMPANY.addressMapUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-white"
                  data-testid="footer-address"
                >
                  {COMPANY.address}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-white/60">
          <div>© {new Date().getFullYear()} {COMPANY.legal}. Tutti i diritti riservati.</div>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <a
              href="https://www.iubenda.com/privacy-policy/84139475"
              className="iubenda-white iubenda-noiframe iubenda-embed iubenda-nostyle hover:text-white transition-colors"
              title="Privacy Policy"
              data-testid="footer-privacy-policy"
            >
              Privacy Policy
            </a>
            <span className="opacity-40">·</span>
            <a
              href="https://www.iubenda.com/privacy-policy/84139475/cookie-policy"
              className="iubenda-white iubenda-noiframe iubenda-embed iubenda-nostyle hover:text-white transition-colors"
              title="Cookie Policy"
              data-testid="footer-cookie-policy"
            >
              Cookie Policy
            </a>
            <span className="opacity-40">·</span>
            <button
              type="button"
              onClick={() => globalThis._iub && globalThis._iub.cs && globalThis._iub.cs.api && globalThis._iub.cs.api.openPreferences()}
              data-testid="footer-cookie-preferences"
              className="hover:text-white transition-colors cursor-pointer underline-offset-2 hover:underline"
            >
              Preferenze Cookie
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
